var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFooterVector(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 8,
    viewBox: "0 0 22 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22 3.99986L21.5 4.49986L21.29 4.70986L18.11 7.88986L17.4 7.17986L20.08 4.49986H0V3.49986H20.08L17.4 0.819863L18.11 0.109863L21.29 3.29986L21.49 3.49986L22 3.99986Z",
    fill: "#CDBB99"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterVector);
export default __webpack_public_path__ + "static/media/FooterVector.16def5f8a3f96fd4a949563ef9535c3a.svg";
export { ForwardRef as ReactComponent };